var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "mt-2" }, [
      _c(
        "form",
        { attrs: { "data-vv-scope": "comment-management" } },
        [
          _c("vs-textarea", {
            staticClass: "mb-2",
            attrs: {
              maxlength: "1000",
              counter: "1000",
              label: "Comentario",
              name: "comment"
            },
            model: {
              value: _vm.comment,
              callback: function($$v) {
                _vm.comment = $$v
              },
              expression: "comment"
            }
          }),
          _vm.errors.first("comment-management.comment")
            ? _c(
                "div",
                {
                  staticClass:
                    "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to",
                  staticStyle: { height: "20px" }
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.errors.first("comment-management.comment")) +
                        " "
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm.enableAttachButton
        ? _c(
            "div",
            { staticClass: "my-5 text-right" },
            [
              _c("UploadMultipleFiles", {
                attrs: {
                  permission: "*",
                  text: "Agregar",
                  "upload-to": _vm.urlFile,
                  "type-button": "small",
                  "button-class": "",
                  "container-class": "text-right"
                },
                on: {
                  input: function($event) {
                    return _vm.addAdditionalFile()
                  }
                },
                model: {
                  value: _vm.file,
                  callback: function($$v) {
                    _vm.file = $$v
                  },
                  expression: "file"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(_vm.commentFiles, function(file) {
          return _c("div", { key: file.id, staticClass: "col-2" }, [
            _c(
              "div",
              { staticClass: "d-flex flex-column align-items-center" },
              [
                _c("vs-icon", {
                  attrs: { icon: "description", size: "30px", color: "primary" }
                }),
                _c("b", { staticClass: "text-truncate w-100 text-center" }, [
                  _vm._v(" " + _vm._s(file.name) + " ")
                ]),
                _c("vs-button", {
                  attrs: { color: "danger", type: "flat", icon: "clear" },
                  on: {
                    click: function($event) {
                      return _vm.removeAdditionalFile(file.id)
                    }
                  }
                })
              ],
              1
            )
          ])
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "text-right mt-4" },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "primary" },
              on: {
                click: function($event) {
                  return _vm.sendAction()
                }
              }
            },
            [_vm._v(" Devolver ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }